import React from "react";
import { Link } from "react-router";
import { RaisedButton } from "material-ui";
import moment from "moment";
import twix from "twix";
import { formatInsertables, isApp } from "../util";
import { colors as Colors } from "material-ui/styles";
import * as ColorManipulator from "material-ui/utils/colorManipulator";
import assign from "lodash/assign";

import TenantButton from "./partials/tenant-button.jsx";
import TenantIcon from "./partials/icons/tenant-icon.jsx";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";
import FilmMarquee from "./partials/film-marquee.jsx";

class Welcome extends React.Component {
  constructor(props) {
    super(props);

    this.getStyles = this.getStyles.bind(this);
  }

  getStyles() {
    let {
        primary1Color,
        accent1Color
      } = this.context.muiTheme.rawTheme.palette,
      { isLarge, tenant, muiTheme } = this.context,
      { prepareStyles } = muiTheme,
      useFixedWaysButtons = tenant.welcome_ways_to_see_fixed_buttons;

    return {
      container: {
        padding: isLarge ? 10 : 25,
        fontSize: 16
      },
      h1: {
        textAlign: "center",
        margin: 0,
        marginTop: isLarge ? 30 : 10,
        fontSize: 45,
        lineHeight: "45px",
        fontWeight: 700
      },
      h2: {
        textAlign: "center",
        margin: 0,
        marginTop: 10,
        marginBottom: 20,
        fontSize: 30,
        lineHeight: "30px",
        fontWeight: 700
      },
      actions: {
        textAlign: "center",
        margin: "0 auto",
        marginBottom: 30
      },
      faq: {},
      dotSeparator: {
        margin: "0 auto",
        marginTop: 30,
        marginBottom: 30,
        width: 14,
        height: 14,
        borderRadius: "50%",
        WebkitTransform: "translateX(-50%)",
        transform: "translateX(-50%)",
        background: accent1Color,
        boxShadow: `30px 0 ${accent1Color}, -30px 0 ${accent1Color}`
      },
      waysToSee: {
        title: {
          textAlign: "center",
          fontSize: 30,
          lineHeight: "0.9"
        },
        container: {
          width: "100%",
          border: "1px solid #ccc",
          borderRadius: 4
        },
        item: prepareStyles({
          flex: isLarge ? 1 : null,
          width: isLarge ? "33.3333%" : "100%",
          display: useFixedWaysButtons
            ? "flex"
            : isLarge
            ? "inline-block"
            : "block",
          flexDirection: "column",
          boxSizing: "border-box",
          borderRight: isLarge && "1px solid #ccc",
          borderBottom: !isLarge && "1px solid #ccc",
          padding: 20
        }),
        lastItem: {
          borderRight: "none",
          borderBottom: "none"
        },
        disabledItem: {
          position: "relative"
        },
        disabledNotice: {
          color: "#fff",
          position: "absolute",
          bottom: 10,
          left: 0,
          width: "100%",
          boxSizing: "border-box",
          backgroundColor: ColorManipulator.fade(primary1Color, 0.7),
          padding: 10,
          zIndex: 1
        },
        icon: {
          height: "64px",
          display: "block",
          verticalAlign: "top",
          fontSize: 64,
          textAlign: "center"
        },
        header: {
          textAlign: "center",
          marginTop: 5,
          fontSize: 19,
          textTransform: "uppercase"
        },
        headerWithTopAction: {
          marginBottom: 10
        },
        list: {
          margin: 0,
          paddingLeft: 10
        },
        line: {
          margin: "5px 0"
        },
        content: prepareStyles({
          flex: useFixedWaysButtons ? "1" : undefined
        }),
        buttonContainer: {
          textAlign: "center",
          marginTop: 20
        }
      },
      membershipAd: {
        textAlign: "center",
        margin: "10px 0",
        padding: 10,
        backgroundColor: Colors.yellow500
      }
    };
  }

  _makeLead() {
    var styles = this.getStyles(),
      { isLarge } = this.context;

    let otherButtons = (this.context.tenant.welcome_other_buttons || []).map(
      (b, i, arr) => {
        if (!
          (isApp() && (b.link === "passes/buy" || b.label === "Buy passes" || b.label === "Passes"))
        ) {
          let button = (
            <TenantButton
              key={i}
              label={b.label}
              style={
                isLarge
                  ? i < arr.length - 1
                    ? { marginRight: 5, marginTop: 5 }
                    : { marginTop: 5 }
                  : {}
              }
              primary={b.primary}
              link={b.link}
              openInNewTab={b.new_tab}
            />
          );

          if (isLarge) {
            return button;
          } else {
            return (
              <div key={i} style={{ marginTop: 5 }}>
                {button}
              </div>
            );
          }
        } else {
          return null;
        }
      }
    );

    let scheduleButton = (
      <RaisedButton
        label={this.context.tenant.welcome_schedule_button_title}
        primary={true}
        style={
          (otherButtons.length ||
            this.context.tenant.welcome_show_film_guide_button) &&
          isLarge && { marginRight: 5, marginTop: 5 }
        }
        onClick={this.context.router.push.bind(this, "/schedule")}
      />
    );

    let filmGuideButton = (
      <RaisedButton
        label={this.context.tenant.display_film_guide || "Film guide"}
        primary={true}
        style={
          isLarge
            ? otherButtons.length && { marginRight: 5, marginTop: 5 }
            : this.context.tenant.welcome_show_schedule_button && {
                marginTop: 5
              }
        }
        onClick={this.context.router.push.bind(this, "/films")}
      />
    );

    let hasIntro =
      this.context.tenant.welcome_intro_content.__html ||
      (isApp() && this.context.tenant.welcome_intro_content_app.__html);

    const _makeWaysToSeeItem = (item, idx, isLast) => {
      return (
        <div
          key={idx}
          className="Eventive--WelcomeButtonBar"
          style={assign(
            {},
            styles.waysToSee.item,
            isLast && styles.waysToSee.lastItem,
            (item.type !== "standalone" ||
              this.props.appSettings.standalone_ticket_sales_enabled) &&
              styles.waysToSee.disabledItem
          )}
        >
          {item.type === "standalone" &&
          !this.props.appSettings.standalone_ticket_sales_enabled ? (
            <div style={styles.waysToSee.disabledNotice}>
              {item.standalone_disabled_error}
            </div>
          ) : null}
          {item.icon ? (
            <TenantIcon name={item.icon} style={styles.waysToSee.icon} />
          ) : null}
          {item.title && <h4 style={styles.waysToSee.header}>{item.title}</h4>}
          {item.bullets ? (
            <ul style={styles.waysToSee.list}>
              {item.bullets.map((b, i) => {
                return (
                  <li key={i} style={styles.waysToSee.line}>
                    {b}
                  </li>
                );
              })}
            </ul>
          ) : null}
          <InjectedTenantHTML
            style={styles.waysToSee.content}
            content={item.description}
          />
          {item.action_text ? (
            <div style={styles.waysToSee.buttonContainer} className="Eventive--WelcomeWaysToSee">
              <TenantButton
                label={item.action_text}
                primary={item.action_primary}
                link={item.action_link}
                disabled={
                  item.type === "standalone" &&
                  !this.props.appSettings.standalone_ticket_sales_enabled
                }
              />
            </div>
          ) : null}
        </div>
      );
    };

    return (
      <div>
        {!this.context.tenant.welcome_hide_title ? (
          <div>
            <h1 style={styles.h1}>
              {this.context.tenant.welcome_custom_header
                ? this.context.tenant.welcome_header
                : this.context.tenant.display_name}
            </h1>
            <h2 style={styles.h2}>{this.context.tenant.welcome_subheader}</h2>
          </div>
        ) : null}
        {this.context.tenant.welcome_show_buttons ? (
          <div style={styles.actions} className="Eventive--WelcomeButtons">
            {this.context.tenant.welcome_show_schedule_button && scheduleButton}
            {this.context.tenant.welcome_show_film_guide_button &&
              (isLarge ? filmGuideButton : <div>{filmGuideButton}</div>)}
            {otherButtons}
          </div>
        ) : null}
        {hasIntro ? (
          <InjectedTenantHTML
            content={
              isApp() &&
              this.context.tenant.welcome_intro_content_app.__html !== ""
                ? this.context.tenant.welcome_intro_content_app
                : this.context.tenant.welcome_intro_content
            }
          />
        ) : null}
        {hasIntro && this.context.tenant.welcome_show_ways_to_see ? (
          <div style={styles.dotSeparator} />
        ) : null}
        {this.context.tenant.welcome_show_ways_to_see ? (
          <div>
            <h2 style={styles.waysToSee.title}>
              {this.context.tenant.welcome_ways_to_see_header.replace(
                "!count!",
                this.context.tenant.welcome_ways_to_see.length +
                  (this.context.tenant.welcome_way_to_see_show_second_row
                    ? this.context.tenant.welcome_ways_to_see_second_row.length
                    : 0)
              )}
            </h2>
            <div
              className={isLarge && "displayFlex"}
              style={styles.waysToSee.container}
            >
              {this.context.tenant.welcome_ways_to_see.map((item, idx) =>
                _makeWaysToSeeItem(
                  item,
                  idx,
                  idx === this.context.tenant.welcome_ways_to_see.length - 1
                )
              )}
            </div>
            {this.context.tenant.welcome_way_to_see_show_second_row ? (
              <div
                className={isLarge && "displayFlex"}
                style={Object.assign({}, styles.waysToSee.container, {
                  marginTop: 20
                })}
              >
                {this.context.tenant.welcome_ways_to_see_second_row.map(
                  (item, idx) =>
                    _makeWaysToSeeItem(
                      item,
                      idx,
                      idx ===
                        this.context.tenant.welcome_ways_to_see_second_row
                          .length -
                          1
                    )
                )}
              </div>
            ) : null}
            {this.context.tenant.member_pass_discount_ad &&
            this.props.appSettings.membership_sales_enabled ? (
              <div style={styles.membershipAd}>
                {this.context.tenant.member_pass_discount_ad.text}{" "}
                <Link to={this.context.tenant.member_pass_discount_ad.link}>
                  {this.context.tenant.member_pass_discount_ad.link_text}
                </Link>
              </div>
            ) : null}
            {this.context.tenant.welcome_ways_to_see_footer &&
            this.context.tenant.welcome_ways_to_see_footer.__html ? (
              <InjectedTenantHTML
                style={{ marginTop: 10 }}
                content={this.context.tenant.welcome_ways_to_see_footer}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    let styles = this.getStyles();

    return (
      <div style={styles.container} className="Eventive--WelcomePage">
        {this.context.tenant.welcome_show_film_marquee ? (<FilmMarquee/>) : null}
        {this._makeLead()}
        {this.context.tenant.welcome_custom.__html ||
        this.context.tenant.welcome_custom_app.__html ? (
          <div>
            <div style={styles.dotSeparator} />
            <InjectedTenantHTML
              style={styles.custom_content}
              content={
                isApp() && this.context.tenant.welcome_custom_app.__html !== ""
                  ? this.context.tenant.welcome_custom_app
                  : this.context.tenant.welcome_custom
              }
            />
          </div>
        ) : null}
      </div>
    );
  }
}

Welcome.contextTypes = {
  muiTheme: React.PropTypes.object,
  router: React.PropTypes.object,
  tenant: React.PropTypes.object,
  isLarge: React.PropTypes.bool
};

export default Welcome;


// WEBPACK FOOTER //
// ./src/app/components/welcome.jsx